import React from "react";
const CustomerSupportIcon: React.FC = () => {
  return (
<svg width="33"
  height="33" 
  viewBox="0 0 33 33" 
  fill="none" xmlns="http://www.w3.org/2000/svg"
>
  <path fill-rule="evenodd" 
    clip-rule="evenodd" 
    d="M16.2917 4.50065C14.1699 4.50065 12.1351 5.34351 10.6348 6.8438C9.13452 8.34409 8.29167 10.3789 8.29167 12.5007V23.1673H1.625V12.5007H5.625C5.625 9.67168 6.74881 6.95857 8.74919 4.95818C10.7496 2.95779 13.4627 1.83398 16.2917 1.83398C19.1206 1.83398 21.8338 2.95779 23.8341 4.95818C25.8345 6.95857 26.9583 9.67168 26.9583 12.5007H30.9583V23.1673H26.9583C26.9583 24.9354 26.256 26.6311 25.0057 27.8814C23.7555 29.1316 22.0598 29.834 20.2917 29.834V31.1673H12.2917V25.834H20.2917V27.1673C21.3525 27.1673 22.3699 26.7459 23.1201 25.9957C23.8702 25.2456 24.2917 24.2282 24.2917 23.1673V12.5007C24.2917 10.3789 23.4488 8.34409 21.9485 6.8438C20.4482 5.34351 18.4134 4.50065 16.2917 4.50065Z" 
    fill="black"/>
</svg>

  );
};

export default CustomerSupportIcon;
